export default __webpack_public_path__ + "static/media/Kulik_Vadim_Valerievich.a6123cfc.webp";